<template>
  <section id="infoCalls">
    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog
      v-if="rangeDialogActive"
      :active="rangeDialogActive"
      module="agentsCdr"
      @dialog:change="eventdialog"
    ></RangeDateDialog>

    <v-card class="shadow-1 mt-5">
      <v-tabs v-model="tab" dark background-color="secondary lighten-1" hide-slider grow>
        <v-tab v-for="(item, index) in tabHeaders" :key="index" @click="getCallsInfo(index)">
          <v-slide-x-transition>
            <v-icon left v-if="tab === index">mdi-check-circle-outline</v-icon>
          </v-slide-x-transition>
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabHeaders" :key="item">
          <v-card flat>
            <v-row align="center">
              <v-col cols="12" md="auto">
                <v-tabs v-model="innerTab" background-color="white lighten-1">
                  <v-tabs-slider color="secondary lighten-1"></v-tabs-slider>
                  <v-tab v-for="(item, index) in innerTabHeaders" :key="index">
                    {{ item }}
                  </v-tab>
                </v-tabs>
              </v-col>
              <!-- Search Input -->
              <v-col cols="12" md="auto" class="ml-auto">
                <v-text-field
                  v-if="!isLoading"
                  filled
                  rounded
                  dense
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Inner Tabs -->
            <v-tabs-items v-model="innerTab">
              <v-tab-item v-for="(item, index) in Object.keys(tableItems[type])" :key="item">
                <v-container class="px-md-7" fluid v-if="customSearchInfo">
                  <v-row dense justify="space-between">
                    <v-col cols="12" md="auto">
                      <span class="blue-grey--text text--darken-3">
                        <span class="caption grey--text">Tipo</span>
                        {{
                          customSearchInfo.call == null
                            ? "Todas"
                            : customSearchInfo.call === 1
                            ? "Salientes"
                            : "Entrantes"
                        }}
                      </span>
                    </v-col>

                    <v-col cols="12" md="auto">
                      <span class="blue-grey--text text--darken-3">
                        <span class="caption grey--text">Desde</span>
                        {{ customSearchInfo.start }}
                      </span>
                      <span class="blue-grey--text text--darken-3">
                        <span class="caption grey--text">Hasta</span>
                        {{ customSearchInfo.end }}
                      </span>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider v-if="customSearchInfo"></v-divider>

                <!-- Tabla -->
                <v-container>
                  <v-skeleton-loader v-if="isLoading" type="table"> </v-skeleton-loader>

                  <v-row v-else dense justify="end">
                    <v-col cols="12">
                      <vuescroll
                        :ops="{
                          bar: {
                            background: '#bacfcec0',
                            keepShow: true,
                          },
                        }"
                      >
                        <v-data-table
                          :headers="tableHeaders[type]"
                          :items="tableItems[type][item]"
                          class="elevation-0"
                          :items-per-page="50"
                          :search="search"
                          disable-pagination
                          hide-default-footer
                        >
                          <template
                            v-slot:[`item.hour`]="{
                              item,
                            }"
                          >
                            <span>{{ item.fecha | getHourFormat }}</span>
                          </template>

                          <template
                            v-slot:[`item.duracion`]="{
                              item,
                            }"
                          >
                            <span>
                              {{ item.duracion | secondsToTimeFormat }}
                            </span>
                          </template>

                          <template
                            v-slot:[`item.hablado`]="{
                              item,
                            }"
                          >
                            <span>
                              {{ item.hablado | secondsToTimeFormat }}
                            </span>
                          </template>

                          <template
                            v-slot:[`item.recordingfile`]="{
                              item,
                            }"
                          >
                            <div
                              :key="item.recordingfile"
                              class="pt-2 pb-1"
                              v-if="item.recordingfile && recordingPathGenerator(item.recordingfile)"
                            >
                              <v-icon>mdi-pLay</v-icon>
                              <v-tooltip bottom>
                                <template
                                  v-slot:activator="{
                                    on,
                                    attrs,
                                  }"
                                >
                                  <audio controls preload="none" v-on="on" v-bind="attrs" controlslist="nodownload">
                                    <source
                                      :src="'https://' + webURL + recordingPathGenerator(item.recordingfile)"
                                      type="audio/wav"
                                    />

                                    <source
                                      :src="'https://' + webURL + recordingPathGenerator(item.recordingfile, true)"
                                      type="audio/mpeg"
                                    />
                                    <p>
                                      Tu navegador no implementa el elemento audio.
                                    </p>
                                  </audio>
                                </template>
                                <span>{{ item.recordingfile }}</span>
                              </v-tooltip>
                            </div>

                            <span class="caption grey--text" v-else>No disponible</span>
                          </template>

                          <template
                            v-slot:[`item.estado`]="{
                              item,
                            }"
                          >
                            <v-chip color="transparent" small>
                              <v-icon left small :color="getSpanishState(item.estado).color"
                                >{{ getSpanishState(item.estado).icon }}
                              </v-icon>
                              {{ getSpanishState(item.estado).text }}
                            </v-chip>
                          </template>
                        </v-data-table>
                      </vuescroll>
                    </v-col>

                    <v-col cols="auto">
                      <p class="grey--text">Total: {{ totalItems[index] }}</p>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                      <v-pagination
                        circle
                        :total-visible="7"
                        color="primary"
                        v-model="currentPage[index]"
                        :length="totalPages[index]"
                        @input="handlePageChange(index, item)"
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
/**
 * @author Abraham Correa
 */
import vuescroll from "vuescroll";
import axios from "axios";
import recordingPathGenerator from "@/components/Utils/recordingPathGenerator.js";

import RangeDateDialog from "../../DatePickers/DateRangePicker";

export default {
  name: "ActivityOverview",
  inject: ["theme"],
  components: {
    RangeDateDialog,
    vuescroll,
  },
  props: {
    innerTabHeaders: {
      type: Array,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      recordingPathGenerator,
      webURL: null,
      request: "",
      infoUrl: `${process.env.VUE_APP_ROOTAPI}`,
      accessToken: localStorage.getItem("token"),
      rangeDialogActive: false,
      tab: null,
      tabHeaders: ["Diario", "Personalizado"],
      innerTab: null,
      isLoading: false,
      search: "",
      customSearchInfo: null,
      axiosInstance: null,
      dataUrl: {
        CDR: ["incoming_day", "outgoing_day", "sumary_custom"],
      },
      customParameters: {},
      tableHeaders: {
        CDR: [
          { text: "Origen", value: "src", width: "10%" },
          {
            text: "Destino",
            value: "dst",
            width: "15%",
          },
          {
            text: "Duración",
            align: "right",
            value: "duracion",
            width: "15%",
            align: "center",
          },
          {
            text: "Hablado",
            align: "right",
            value: "hablado",
            width: "15%",
            align: "center",
          },
          {
            text: "Audio",
            align: "center",
            value: "recordingfile",
            width: "15%",
            align: "center",
          },
          {
            text: "Estado",
            value: "estado",
            width: "15%",
          },
        ],
      },
      tableItems: {
        CDR: {
          incoming: {},
          outcoming: {},
        },
      },
      currentPage: [1, 1],
      totalPages: [],
      options: {},
      render: false,
      totalItems: [0, 0],
      // Table Data
      CDRInfo: null,
    };
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },
  },

  created() {
    this.axiosInstance = axios.create({
      baseURL: this.infoUrl,
      headers: {
        Authorization: `Bearer ${this.accessToken}`,
      },
    });
    this.getCallsInfo(0);
  },

  methods: {
    /**
     * Busca los datos de las llamadas
     * @param {Number} index - Indice de la Tab
     */
    async getCallsInfo(index) {
      this.isLoading = true;

      // Si es personalizado, abrimos el modal
      if (index === 1) {
        this.rangeDialogActive = true;
        this.isLoading = false;
        return;
      }

      try {
        const requests = this.dataUrl[this.type]
          .filter((_, i) => i !== 2) // quitamos sumary_custom
          .map((url) => this.axiosInstance.get(`/agents/sumary/${url}`));

        const [incomingRes, outcomingRes] = await axios.all(requests);

        // Incoming
        this.tableItems[this.type].incoming = incomingRes.data.data.data ?? [];

        // Outcoming
        this.tableItems[this.type].outcoming = outcomingRes.data.data.data ?? [];

        // Totales
        this.totalItems = [incomingRes.data.data.total ?? 0, outcomingRes.data.data.total ?? 0];

        // Paginación
        this.totalPages = [incomingRes.data.data.last_page ?? 1, outcomingRes.data.data.last_page ?? 1];

        this.currentPage = [incomingRes.data.data.current_page ?? 1, outcomingRes.data.data.current_page ?? 1];

        // URL base para audios (viene fuera de data)
        this.webURL = incomingRes.data.url;
      } catch (error) {
        console.error("Error cargando llamadas:", error);

        if (error.response?.status === 401) {
          this.$snotify.error("Su sesión ha finalizado.", "Error");
          this.$store.dispatch("passport/RESET_AUTH");
          this.$router.push({ name: "login" });
        }
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Cambia la pagina actual
     * @param {string} index - Indice de la tabla mostrada
     * @param {string} table - Nombre de la tabla mostrada
     */
    async handlePageChange(index, table) {
      this.isLoading = true;

      const request = this.tab === 1 ? "sumary_custom" : this.dataUrl[this.type].find((url, i) => i === index);

      const page = this.currentPage[index];

      try {
        const { data } =
          this.tab === 1
            ? await this.axiosInstance.post(`/agents/sumary/${request}?page=${page}`, {
                ...this.customParameters,
                call: index + 1,
              })
            : await this.axiosInstance.get(`/agents/sumary/${request}?page=${page}`);
        this.tableItems[this.type][table] = data.data;
      } catch (err) {
        console.log(err);
      }
      this.isLoading = false;
    },

    /**
     * [Obtener estado en español]
     * @param {string} state [Estado de la llamada]
     */
    getSpanishState(state) {
      if (state == "ANSWERED") {
        return {
          text: "Contestada",
          color: "success",
          icon: "mdi-phone-outline",
        };
      } else {
        return {
          text: "No contestada",
          color: "error",
          icon: "mdi-call-missed",
        };
      }
    },

    /**
     * Maneja el evento del diálogo de rango y carga la información
     * de llamadas entrantes y salientes.
     *
     * @async
     * @param {string} data - Acción del diálogo ("cerrar" u otra)
     * @param {Object} parameters - Parámetros personalizados para la consulta
     * @returns {Promise<void>}
     */
    async eventdialog(data, parameters) {
      this.rangeDialogActive = false;

      // Si se cierra el diálogo, restauramos estado inicial
      if (data === "cerrar") {
        this.tab = 0;
        this.getCallsInfo(0);
        return;
      }

      const url = this.dataUrl[this.type].slice(-1);
      this.isLoading = true;

      try {
        const [resIncoming, resOutcoming] = await Promise.all([
          this.axiosInstance.post(`/agents/sumary/${url}`, {
            ...parameters,
            call: 1,
          }),
          this.axiosInstance.post(`/agents/sumary/${url}`, {
            ...parameters,
            call: 2,
          }),
        ]);

        this.tableItems[this.type].incoming = resIncoming.data.data.data;
        this.tableItems[this.type].outcoming = resOutcoming.data.data.data;

        this.totalItems = [resIncoming.data.data.total, resOutcoming.data.data.total];

        this.totalPages = [resIncoming.data.data.last_page, resOutcoming.data.data.last_page];

        this.currentPage = [resIncoming.data.data.current_page, resOutcoming.data.data.current_page];

        this.webURL = res.data.url;

        this.customParameters = parameters;
      } catch (error) {
        console.error("Error cargando resumen de llamadas:", error);
      } finally {
        this.isLoading = false;
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
      }
    },

    descargarAudio(recordingfile, changeToMp3 = false) {
      const path = this.recordingPathGenerator(recordingfile, changeToMp3); // Generar path

      const url = `https://${this.webURL}${path}`;

      const enlace = document.createElement("a");
      enlace.href = url;
      enlace.target = "_blank"; // Abre en una nueva ventana/tab
      enlace.download = recordingfile;

      enlace.click();
    },
  },
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
}

audio {
  height: 35px !important;
}
</style>
